export const DEFAULT_HEARTBEAT_INTERVAL_MS = 59700;

export interface HeartbeatListener {
  /**
   * @param playerCurrentTime the current player playback time of the video in seconds.
   */
  onHeartbeat: (playerCurrentTime: number) => void;
}

/** Get the current player playback time of the video in seconds. */
type PlayerCurrentTimeCallback = () => number;

export class HeartbeatService {
  private heartbeatInterval: ReturnType<typeof setInterval> | undefined;
  private listener: HeartbeatListener | undefined;
  private readonly getPlayerCurrentTime: PlayerCurrentTimeCallback;

  constructor(getPlayerCurrentTime: PlayerCurrentTimeCallback) {
    this.getPlayerCurrentTime = getPlayerCurrentTime;
  }

  setListener(listener: HeartbeatListener) {
    this.listener = listener;
  }

  startHeartbeat() {
    if (this.heartbeatInterval !== undefined) {
      this.clearHeartbeat();
    }
    this.heartbeatInterval = setInterval(() => {
      this.listener?.onHeartbeat(this.getPlayerCurrentTime());
    }, DEFAULT_HEARTBEAT_INTERVAL_MS);
  }

  stopHeartbeat() {
    this.clearHeartbeat();
  }

  private clearHeartbeat() {
    clearTimeout(this.heartbeatInterval);
    this.heartbeatInterval = undefined;
  }
}
